/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFAQ = {
  init() {
    const $faqHeading = $('.faq-accordion > .faq-accordion-div > dt > button');
    // const $faqHeading = $('.faq-accordion > .faq-accordion-div > .contentItem');
    $('.faq-accordion > .faq-accordion-div > dd').attr('aria-hidden', true);

    $faqHeading.attr('aria-expanded', false);

    $faqHeading.off('click activate').on('click activate', function () {
      $(this).parent().next().css('border-bottom', '1px solid #505050')
      const faqIcons = $(this).find('.icon');

      const state = $(this).attr('aria-expanded') === 'false';
      if(state) {
        $(this).parent().next().css('border-bottom', '1px solid #505050')
        $(this).parent().css('border-bottom', 'none')
      }
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(() => {
        if (faqIcons.hasClass('icon--active')) {
          faqIcons.toggleClass('icon--active');
        }
        if(!state) {
          $(this).parent().css('border-bottom', '1px solid #f1f1f1')
        } 
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });

    $faqHeading.on('keydown', function (event) {
      const keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload() {
    $('.faq-accordion > .faq-accordion-div > .contentItem > dt > button').off('click activate');
    $('.faq-accordion > .faq-accordion-div > .contentItem > dt > button').off('keydown');
  },
};

/******/ })()
;